var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearFormatButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66699 12.2929L6.17892 2.6665H8.42127L10.74 9.02219L9.30381 10.3785L9.08079 9.68756H5.45345L4.61256 12.2929H2.66699ZM6.27784 7.17058L5.89862 8.34811H8.6521L8.27288 7.17058C8.09701 6.66031 7.92663 6.13533 7.76175 5.59562C7.60787 5.05592 7.45398 4.52112 7.30009 3.99123H7.23414C7.09125 4.53094 6.93736 5.07064 6.77248 5.61034C6.61859 6.14023 6.45371 6.66031 6.27784 7.17058Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99623 10.7218L11.3007 9.48985C11.5404 9.26345 11.9291 9.26345 12.1688 9.48985L13.1539 10.4202C13.3936 10.6466 13.3936 11.0137 13.1539 11.2401L11.8494 12.472L9.99623 10.7218Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92561 12.5528C8.68588 12.3264 8.68588 11.9593 8.92561 11.7329L9.75938 10.9455L11.6126 12.6957L11.1174 13.1634C10.9954 13.2786 10.8276 13.34 10.6552 13.3326L9.94538 13.3018C9.79248 13.2951 9.64772 13.2348 9.53949 13.1326L8.92561 12.5528Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFormatButton);
export default __webpack_public_path__ + "static/media/clearFormatButton.f4942e99e0d266b33ec8af2d4bc510a9.svg";
export { ForwardRef as ReactComponent };